/* istanbul ignore file: Directive */
'use strict';

/**
 * Render an image of a simcard while highlighting where the user can find the ICCID.
 *
 * For info on how this works, have a look at the css.
 */
customerZone.directive('simIccidDisplay', [function($compile, $log, utils){
    return {
        template: '<div><div>&nbsp;</div></div>',
        link: function(scope, element){ element.addClass('sim-iccid-display'); }
    };
}]);
